import Footer from './Footer'

import React, { useEffect } from 'react'
import TopBar from './TopBar'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flexGrow: 1,
    paddingTop: 64
  }
}))

function UPSHomePageLayout({ children }) {
  const classes = useStyles()
  sessionStorage.setItem('homePagePath', '/na-mig/ups')
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    link.href = process.env.PUBLIC_URL + '/favicon-ups.ico'
  }, [])

  return (
    <div className={classes.root}>
      <TopBar />
      <div className={classes.content}>{children}</div>
      <Footer />
    </div>
  )
}

export default UPSHomePageLayout
